module.exports = __webpack_public_path__ + "static/media/icon-pix-grey.a38b6103.png";